/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyChatActivityLastMessage_EmbedChatActivity = {
    readonly lastMessage: {
        readonly " $fragmentRefs": FragmentRefs<"TypographyMessageText_EmbedMessage">;
    } | null;
    readonly " $refType": "TypographyChatActivityLastMessage_EmbedChatActivity";
};
export type TypographyChatActivityLastMessage_EmbedChatActivity$data = TypographyChatActivityLastMessage_EmbedChatActivity;
export type TypographyChatActivityLastMessage_EmbedChatActivity$key = {
    readonly " $data"?: TypographyChatActivityLastMessage_EmbedChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyChatActivityLastMessage_EmbedChatActivity">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyChatActivityLastMessage_EmbedChatActivity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Message",
      "kind": "LinkedField",
      "name": "lastMessage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TypographyMessageText_EmbedMessage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
(node as any).hash = '0180fcf5633329a572f84b7093e1ea65';
export default node;
